/** Pure helpers for customers list/detail/search — unit-tested without Vue mount. */

export function customerToForm(customer) {
  return {
    id: customer?.id,
    name: customer?.name || '',
    inn: customer?.inn || '',
    director: customer?.director || '',
    phone: customer?.phone || '',
    email: customer?.email || '',
    address: customer?.address || '',
    transport_conditions: customer?.transport_conditions || '',
  }
}

export function isCustomerFormModified(form, customer) {
  const baseline = customerToForm(customer)
  const current = form || {}
  return Object.keys(baseline).some((key) => current[key] !== baseline[key])
}

export function normalizeCustomersItems(items) {
  return Array.isArray(items) ? items : []
}

export function customersFromListResponse(response) {
  if (!response || typeof response !== 'object') {
    return { items: [], currentPage: 1, totalPages: 1 }
  }
  return {
    items: normalizeCustomersItems(response.customers),
    currentPage: Number(response.current_page) > 0 ? Number(response.current_page) : 1,
    totalPages: Number(response.total_pages) > 0 ? Number(response.total_pages) : 1,
  }
}

/** Full-page list loader must not cover the create form (would wipe inputs). */
export function shouldShowCustomersListLoader({ statusLoading, showCreateForm, creating }) {
  return Boolean(statusLoading && !showCreateForm && !creating)
}

/** Detail loader must stay off while saving so the edit form is not unmounted. */
export function shouldShowCustomerDetailLoader({ statusLoading, saving }) {
  return Boolean(statusLoading && !saving)
}

export function customerCreateSucceeded(created) {
  return Boolean(created && created.id)
}

export function buildCustomerSearchPayload(searchText) {
  const text = String(searchText ?? '').trim()
  if (!text) return null
  if (/^\d+$/.test(text)) return { inn: text }
  return { name: text }
}

export function displayCustomerField(value) {
  return value == null || value === '' ? '—' : value
}
